import { useTranslation } from "react-i18next";
import { useInterviewContext } from "../InterviewContext";
import SalaryPerLocation from "./SalaryPerLocation";

export default function SalaryPerLocationList() {
  const {
    interview,
    setInterview,
    viewMode,
    contractTypes,
    monetaryList,
    errors
  } = useInterviewContext();

  let { t } = useTranslation();

  function changeSalaryCondition(salaryPerLocation, index) {
    let expectedSalaryPerLocation = [...interview.expectedSalaryPerLocation];
    expectedSalaryPerLocation[index] = salaryPerLocation;
    setInterview((prevInterview) => ({
      ...prevInterview,
      expectedSalaryPerLocation: expectedSalaryPerLocation
    }));
  }

  function addNewLocation() {
    let expectedSalaryPerLocation = [...interview.expectedSalaryPerLocation];
      expectedSalaryPerLocation.push({
        currentLocation: {}, 
        salaryExpected: null
      });
      setInterview({
        ...interview,
        expectedSalaryPerLocation: expectedSalaryPerLocation
      });
  }

  function deleteSalaryLocation (index) {
    let expectedSalaryPerLocation = [...interview.expectedSalaryPerLocation];
    expectedSalaryPerLocation.splice(index, 1);
    setInterview({
      ...interview,
      expectedSalaryPerLocation: expectedSalaryPerLocation
    });
  };

  return (
    <>
      <h1>{t("Salary per Location")}</h1>
      {interview.expectedSalaryPerLocation?.map((salaryPerLocation, index) => (
        <SalaryPerLocation
          key={index}
          model={salaryPerLocation}
          setModel={(salaryPerLocation) =>
            changeSalaryCondition(salaryPerLocation, index)
          }
          viewMode={viewMode}
          contractTypes={contractTypes}
          monetaryList={monetaryList}
          errors={errors}
          index={index}
          deleteSalaryLocation={deleteSalaryLocation}
        />
      ))}
      <div className="col-md-6">
        <button
          onClick={addNewLocation}
          type="button"
          className={`app-button btn-prime btn-lg add-location-button-position`}
          disabled={!interview.expectedSalaryPerLocation[interview.expectedSalaryPerLocation.length - 1]?.salaryExpected}
        >
          {t("+ Add Location")}
        </button>
      </div>
    </>
  );
}